import axios, { AxiosRequestConfig } from 'axios';

import Env from './env';
import { notification } from 'ant-design-vue';
import store from '@/store/store';

// import Vue from 'vue'

// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';//配置请求头

//添加一个请求拦截器;
axios.interceptors.request.use(
    (config) => {
        if ((config.url as string).includes('api-token-auth')) {
            config.headers['Authorization'] = '';
        }
        return config;
    },
    function (error) {
        // Do something with request error
        return Promise.reject(error);
    },
);

axios.defaults.withCredentials = true;
// 添加一个响应拦截器
axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    // 401 清除token信息并跳转到登录页面
                    // logout();
                    // void newrouter.replace({
                    //     path: 'login',
                    //     query: { redirect: newrouter.currentRoute.fullPath },
                    // });
                    notification.error({
                        message: 'Unauthorized',
                        description: '用户认证失败',
                    });
                    break;
                case 403:
                    notification.error({
                        message: '权限出错',
                        description: '未得到相关权限，请联系工作人员',
                    });
                    // 401 清除token信息并跳转到登录页面
                    // store.commit(types.LOGOUT);
                    // router.replace({
                    //     path: 'login',
                    //     query: {redirect: router.currentRoute.fullPath}
                    // })
                    break;
            }
        }
        return Promise.reject(error.response.data);
    },
);

export { axios };
/**
 * setConfig
 */
export function setConfig(config?: AxiosRequestConfig): AxiosRequestConfig {
    if (!config) {
        config = {} as AxiosRequestConfig;
    }
    if (!config.headers) {
        config.headers = {};
    }
    config.headers['Authorization'] = `Bearer ${store.getters.getToken} `;
    config.headers['Content-Type'] = 'application/json';
    return config;
}

//通用方法
export const POST = <T>(url: string, params: object, config: any): Promise<T> => {
    //eslint-disable-line
    const new_config = setConfig(config);
    let base = '';
    if (!store.state.iesMode) {
        base = Env.baseURL;
    } else {
        base = Env.iesURL;
    }
    return axios.post(`${base}${url}`, params, new_config).then((res) => res.data);
};

export const GET = <T>(url: string, params?: object, config?: AxiosRequestConfig, newUrl?: string): Promise<T> => {
    const new_config = setConfig(config);
    let base = '';
    if (!store.state.iesMode) {
        base = Env.baseURL;
    } else {
        base = Env.iesURL;
    }
    return (
        axios
            // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
            .get<T>(`${newUrl ?? base}${url}`, { params: params, ...new_config })
            .then((res) => res.data)
    );
};
export const PUT = <T>(url: string, params: object, config?: { headers?: Record<string, string> }): Promise<T> => {
    let base = '';
    if (!store.state.iesMode) {
        base = Env.baseURL;
    } else {
        base = Env.iesURL;
    }
    const new_config = setConfig(config as { headers: Record<string, string> });
    return axios.put(`${base}${url}`, params, new_config).then((res) => res.data);
};

export const DELETE = (url: string, config?: object): any => {
    //eslint-disable-line
    let base = '';
    if (!store.state.iesMode) {
        base = Env.baseURL;
    } else {
        base = Env.iesURL;
    }
    const new_config = setConfig(config as { headers: Record<string, string> });
    return axios.delete(`${base}${url}`, new_config).then((res) => res.data);
};

export const PATCH = (url: string, params: object, config?: any): any => {
    //eslint-disable-line
    let base = '';
    if (!store.state.iesMode) {
        base = Env.baseURL;
    } else {
        base = Env.iesURL;
    }
    const new_config = setConfig(config);
    return axios.patch(`${base}${url}`, params, new_config).then((res) => res.data);
};
